<template>
<div class="alertSelectPayment row">
    <img src="https://preprod.api.defipix.fr/logos/close_200.png" class="closeBtn" @click="close" />
    <h4 class="font-weight-bold col-12">Vous y êtes presque !<i v-if="!noEmojis" class="em em-see_no_evil" aria-role="presentation" aria-label="SEE-NO-EVIL MONKEY"/></h4>
    <p>Sélectionnez un moyen de paiement parmis ceux proposé</p>
</div>
</template>

<script>

export default {
    data() {
        return {
            noEmojis: this.$store.getters.reservation_client.noEmojis,
        }
    },
    methods: {
        close: function() {
            this.$parent.alertSelectPayment = false;
        }
    }
}
</script>

<style scoped>
h5, h4, p {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.alertSelectPayment {
    max-width: 30em;
    height: fit-content;
    z-index: 1;
    position: fixed;
    top: 1em;
    left: 1em;
    right: 1em;
    bottom: 1em;
    margin: auto;
    background-color: rgb(248, 248, 248);
    box-shadow: 0px 0px 5px 0px #105588;
    border-radius: 5px;
    overflow: auto;
    padding: 2em;
}

.submit {
    display: block;
    margin: 1em auto 0 auto;
    padding: 1em;
    border-radius: 5px;
    border: none;
    background-color: #25327B;
    color: white;
}

.closeBtn {
    width: 1em;
    position: absolute;
    top: 1em;
    right: 1em;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/AlertSelectPayment.vue